<div class="dialog-subtitle mb10" *ngIf="sanitizedSubtitle" [innerHTML]="sanitizedSubtitle"></div>

<rx-tip [showClose]="payload.tipClose" [tipTemplate]="payload.tipTemplate" class="mb20">
  {{ payload.tip }}
</rx-tip>

<p *ngIf="payload.label" class="mb20 label">{{ payload.label }}</p>

<form [formGroup]="formGroup">
  <div formArrayName="fields" class="fields">
    <div *ngFor="let field of fields.controls; let i = index" class="rows" [formGroupName]="i">
      <ng-container [ngSwitch]="payload.fields[i].componentType">
        <ng-container *ngSwitchCase="componentTypes.Input">
          <div class="mb10">
            <rx-input
              [id]="'m-input-' + i"
              formControlName="value"
              rxFormControlError
              [customErrors]="payload.fields[i].customErrors || {}"
              [placeholder]="payload.fields[i].placeholder"
              [hasInlineInfo]="payload.fields[i].hasInlineInfo"
              [keepPlaceholder]="payload.fields[i].keepPlaceholder"
              [maxLength]="payload.fields[i].maxLength"
            ></rx-input>
            <div class="form-hint text-error" *ngIf="!isFormDirty && fields.controls[i].dirty">
              Section with that name already exists. Duplicate sections are not allowed. Please rename.
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Textarea">
          <div class="mb10">
            <rx-textarea
              [id]="'m-textarea-' + i"
              formControlName="value"
              rxFormControlError
              [customErrors]="payload.fields[i].customErrors || {}"
              [placeholder]="payload.fields[i].placeholder"
              [hasInlineInfo]="payload.fields[i].hasInlineInfo"
              [keepPlaceholder]="payload.fields[i].keepPlaceholder"
              [maxLength]="payload.fields[i].maxLength"
            ></rx-textarea>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Toggle">
          <div class="mb10">
            <rx-toggle
              [id]="'m-toggle-' + i"
              formControlName="value"
              rxFormControlError
              [label]="payload.fields[i].label"
            >
            </rx-toggle>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Radio">
          <div class="mb10">
            <rx-list-radio-item
              [id]="'m-radio-' + i"
              formControlName="value"
              rxFormControlError
              [title]="payload.fields[i].title"
              [description]="payload.fields[i].description"
              [icon]="payload.fields[i].icon"
              [data]="payload.fields[i].data"
            >
            </rx-list-radio-item>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Select">
          <div class="mb10">
            <rx-select
              [id]="'m-select-' + i"
              formControlName="value"
              rxFormControlError
              [optionTemplate]="payload.fields[i].optionTemplate"
              [customErrors]="payload.fields[i].customErrors || {}"
              [class]="payload.fields[i].styleClass"
              [items]="payload.fields[i].items"
              bindLabel="name"
              bindValue="id"
              [placeholder]="payload.fields[i].placeholder"
            ></rx-select>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Autocomplete">
          <div class="mb10">
            <rx-autocomplete
              [id]="'m-autocomplete-' + i"
              formControlName="value"
              rxFormControlError
              [customErrors]="payload.fields[i].customErrors || {}"
              [items]="payload.fields[i].items"
              [placeholder]="payload.fields[i].placeholder"
              [searchable]="searchable"
            >
            </rx-autocomplete>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Phone">
          <div class="mb10">
            <rx-input-intl-phone
              [id]="'m-input-phone-' + i"
              rxFormControlError
              [customErrors]="payload.fields[i].customErrors || {}"
              formControlName="value"
            >
            </rx-input-intl-phone>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.Checkbox">
          <div class="mb10">
            <rx-checkbox
              [id]="'m-checkbox-' + i"
              rxFormControlError
              [customErrors]="payload.fields[i].customErrors || {}"
              formControlName="value"
              [title]="payload.fields[i].title"
            >
            </rx-checkbox>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.RadioGroup">
          <rx-radio-group [id]="'m-radio-group-' + i" formControlName="value" rxFormControlError>
            <ng-container *ngFor="let item of payload.fields[i].items">
              <ng-template rxRadioRow [value]="item.value"> {{ item.name }}</ng-template>
            </ng-container>
          </rx-radio-group>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.UploadThumbnail">
          <div class="mb10">
            <rx-upload-thumbnail
              [id]="'m-checkbox-' + i"
              formControlName="value"
              rxFormControlError
            ></rx-upload-thumbnail>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="componentTypes.HorizontalLine">
          <div>
            <hr />
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</form>

<ng-template #appointmentTemplate let-item="item">
  <div class="appointment-item">
    <div class="left">
      <div class="doctor">{{ item._original.Customer }}</div>
      <div class="service">{{ item._original.Service }}</div>
    </div>
    <div class="date">{{ item._original.StartDate | date: 'MM/dd/yyyy' }}</div>
  </div>
</ng-template>
